// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"Map_mapContainer__3XkDG","searchInputWrapper":"Map_searchInputWrapper__1D570","selectedPlaceWrapper":"Map_selectedPlaceWrapper__2cj94"};